export default __webpack_public_path__ + "static/media/Evento.537d9a25.svg";